<template>
    <thead class="table-header">
        <slot />
    </thead>
</template>

<script lang="ts">
export default {
    name: "TableHeader",
};
</script>

<style>
@import "@/style/data-tables.css";
</style>
